(ns app.front.view.group.admin.templates.document-editor
  (:require [app.domain.template.model :as template-model]
            [app.front.ui.template-editor :as template-editor]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.templates.subs :as template-subs]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [schema-tools.core :as st]
            [schema.core :as s]))

(s/defschema SnippetEditorProps
  (st/merge
    {:tr       s/Any
     :group-id s/Int}
    (st/optional-keys
      {:document-id     s/Int
       :read-only?      s/Bool
       :get-db-snippet  s/Any
       :save-db-snippet s/Any})))

(s/defschema TemplateEditorProps
  (st/merge
    {:tr                 s/Any
     :title              s/Any
     :images             [s/Any]
     :placeholders       [(s/cond-pre s/Str
                                      {:id s/Str :title s/Str})]
     :group-id           s/Int
     :document-id        s/Int
     :html-fragment-type s/Keyword
     :on-start-edit      s/Any
     :on-end-edit        s/Any
     :*editing?          s/Any}
    (st/optional-keys
      {:small?                     s/Bool
       :read-only?                 s/Bool
       :replace-template           s/Any
       :review-placeholder-options s/Any
       :css-fragment-type          s/Keyword
       :preview-url                s/Str})))

(s/defn editor
  "A special template-editor that can handle document-fragment actions out of the box

  give also :tr, :title, :preview-url, :placeholders etc stuff used by template-editor"
  [{:keys [html-fragment-type css-fragment-type group-id document-id] :as props} :- TemplateEditorProps
   & children]
  (let [html-frag (<sub [::template-subs/fragment-data-for document-id html-fragment-type])
        css-frag  (<sub [::template-subs/fragment-data-for document-id css-fragment-type])]
    (into [template-editor/editor
           (merge props
                  {:html-template (:content html-frag)
                   :html-only?    true
                   :on-save       #(>evt [::template-subs/save-fragment group-id (:id html-frag) %])}
                  (when css-fragment-type
                    {:print-css  (:content css-frag)
                     :on-save    #(>evt [::template-subs/save-fragments group-id (:id html-frag) (:id css-frag) %1 %2])
                     :html-only? false}))]
          children)))

(s/defn editor-for-snippet
  "Template editor for snippet hierarchy defined in supplied config.
   Supports both document fragment-reference and db-reference storage.
   List of children supplied renders before nested sub-snippets. Sub-snippet children not yet implemented.

   For db storage support, supply `(fn get-db-snippet [db-reference])` and `(fn save-db-snippet [[db-reference new-html]])`"
  [{:keys [db-reference fragment-reference pdf-title template-variables snippets]} :- template-model/SnippetConfig
   {:keys [tr document-id group-id get-db-snippet save-db-snippet read-only?] :as props} :- SnippetEditorProps
   & children]
  (let [snippet-template        (cond (and db-reference save-db-snippet)
                                      (get-db-snippet db-reference)

                                      fragment-reference
                                      (-> (<sub [::template-subs/fragment-data-for document-id fragment-reference])
                                          :content))
        fragment-id             (when (and (not db-reference) fragment-reference)
                                  (<sub [::template-subs/fragment-id document-id fragment-reference]))
        on-save-fn              (fn [html _]
                                  (cond (and db-reference save-db-snippet)
                                        (save-db-snippet [db-reference html])

                                        fragment-id
                                        (>evt [::template-subs/save-fragment group-id fragment-id html])

                                        fragment-reference
                                        (>evt [::template-subs/create-fragment group-id document-id fragment-reference html])))
        template-variable-names (->> template-variables
                                     (keep (fn [v]
                                             (if (string? v)
                                               v
                                               (:variable-name v)))))]
    (->
      [template-editor/editor
       (-> {:html-template snippet-template
            :html-only?    true
            :title         [:h4 (tr [pdf-title])]
            :on-save       on-save-fn
            :placeholders  template-variable-names}
           (util/mmap tr read-only?)
           (text-editor/with-external-edit-state pdf-title))]
      (into children)
      (into (->> snippets
                 (remove :hide-html-editor?)
                 (map #(editor-for-snippet % props)))))))
